import z from "zod";

import { optionalPhoneZodField, phoneZodField } from "@/schemas/shared/phone-field-schema";

export const profileSettingsFormSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
  cellPhone: phoneZodField,
  homePhone: optionalPhoneZodField,
  address: z.string().min(1, "Address is required"),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  zip: z.string().min(1, "Zip code is required"),
  country: z.string().min(1, "Country is required"),
});

export type ProfileSettingsFormType = z.infer<typeof profileSettingsFormSchema>;
